import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { api } from "../../api/client.ts";
import { keys } from "../../api/queryKeys.ts";
import { plural } from "../review/rules.ts";

export { REVIEW_LABELS } from "../review/rules.ts";

/**
 * Continuing the steps parked on signals, the one action left here: decisions
 * on the companies are taken in Prospects (`pages/prospects/prospectReview.ts`).
 */
export function useContinueSignals(onDone?: () => void) {
  const queryClient = useQueryClient();
  const refresh = () => {
    queryClient.invalidateQueries({ queryKey: keys.signal.all });
    queryClient.invalidateQueries({ queryKey: keys.prospect.all });
    onDone?.();
  };
  return useMutation({
    mutationFn: (signalIds: string[]) => api.continueSignals(signalIds),
    onSuccess: ({ results }) => {
      const approved = results.reduce((n, r) => n + r.approved, 0);
      const skipped = results.filter((r) => r.approved === 0);
      if (approved === 0) {
        toast.error(skipped[0]?.skipped[0] ?? "Nothing to continue");
      } else {
        toast.success(
          `Continued ${plural(approved, "step")}` +
            (skipped.length ? `, ${plural(skipped.length, "signal")} left waiting` : ""),
        );
      }
      refresh();
    },
    onError: refresh,
  });
}
